// extracted by mini-css-extract-plugin
module.exports = {"proofColumn":"styles_proofColumn__2qZlv","proofImage":"styles_proofImage__1yHvT","compare":"styles_compare__UzZC_"};